import React from 'react'
import cx from 'classnames'

import s from './CircleLoader.scss'


const CircleLoader = ({ className, color = 'brand', center, title }) => (
  <div
    className={cx(className, s.loader, {
      [s[color]]: color,
      [s.center]: center,
    })}
    title={title}
  />
)


export default CircleLoader
